export default __webpack_public_path__ + "static/media/stylist_image_3.cac80a6a.webp";